
import Cookie from "js-cookie";
import { Component, Vue } from "nuxt-property-decorator";
import RouterLink from "~/components/atoms/text/RouterLink.vue";

@Component({
  components: {
    RouterLink,
  },
})
export default class WarningBanner extends Vue {
  showWarning = false;

  mounted() {
    this.checkDismissedCookie();
    this.adjustCookiebotPosition();
  }

  checkDismissedCookie() {
    const cookieName = "warningBannerDismissed";
    const dismissed = Cookie.get(cookieName);
    this.showWarning = !dismissed;
  }

  dismissWarning() {
    const cookieName = "warningBannerDismissed";
    Cookie.set(cookieName, "true");
    this.showWarning = false;
    this.resetCookiebotPosition();
  }

  adjustCookiebotPosition() {
    if (this.showWarning) {
      const style = document.createElement("style");
      style.id = "cookiebot-offset";
      style.textContent = `
          @media screen and (max-width: 600px) {
            #CookiebotWidget:not(.CookiebotWidget-inactive) {
              bottom: 60px !important;
            }
          }
        `;
      document.head.appendChild(style);
    }
  }

  resetCookiebotPosition() {
    const adjustmentStyle = document.getElementById("cookiebot-offset");
    if (adjustmentStyle) {
      adjustmentStyle.remove();
    }
  }

  beforeDestroy() {
    this.resetCookiebotPosition();
  }
}
